const tbd = {

	elem: {
		component: document.querySelector('.tbd'),
		images: document.querySelectorAll('.tbd__image'),
		cards: document.querySelectorAll('.tbd .splide__slide')
	},

	mql: {
		large: window.matchMedia('(min-width: 1024px)')
	},

	// This is a normal slider (see slider.js) but we want an additional behavior: at large sizes (when all four elements are displayed) we need to switch the background image currently being displayed when the user mouses over a card
	init() {
		if(tbd.elem.component) {
			tbd.elem.cards.forEach(function(element) {
				element.addEventListener('mouseenter', function(event) {
					if(tbd.mql.large.matches) {
						let active = event.currentTarget.querySelector('.tbd__card').id;
						tbd.elem.images.forEach(function(element) {
							element.classList.remove('tbd__image--active');
							if(element.dataset.tab === active) {
								element.classList.add('tbd__image--active');
							}
						});
					}
				});
			})
			
		}
	}
};

export { tbd };
